import {IDotRezApiService} from "./dot-rez-api.service.interface";
import {ServiceBase} from "../service-base";
import {IDotRezBookingSession} from "./session/booking-session/dot-rez-booking.session.interface";
import {DotRezBookingSession} from "./session/booking-session/dot-rez-booking.session";
import {buildFullUrl, isHttpErrorStatusCode} from "../http/http-helpers";
import {VoidDotRezSessionTimer} from "./session/session-timer/void-dot-rez-session-timer";
import {DeeplinkAgentTokenRequest} from "../airline-webapi/requests/deeplink-agent-token.request";

export class DotRezApiService extends ServiceBase implements IDotRezApiService {

    buildDotRezUrl(path: string ) {
        if(!this.services.configuration.dotRezApiUrl) {
            throw new Error('dotRezApiUrl was not initialized');
        }
        return buildFullUrl(this.services.configuration.dotRezApiUrl, path);
    }

    async createAnonymousToken(): Promise<string> {
        let {token} = await this.services.airlineWebapi.createDotRezAnonymousToken();
        token = await this.services.crypto.decryptMessage(token);
        return token;
    }

    async getDeepLinkAgentToken(request: DeeplinkAgentTokenRequest): Promise<string> {
        let {dotRezToken} = await this.services.airlineWebapi.getDeepLinkAgentToken(request);
        dotRezToken = await this.services.crypto.decryptMessage(dotRezToken);
        return dotRezToken;
    }

    async tryRefreshToken(token: string): Promise<void> {
        const response = await fetch(this.buildDotRezUrl('/api/nsk/v1/token'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                ...this.services.configuration.dotRezApiSubscriptionKeyHeader
            }
        });

        if(isHttpErrorStatusCode(response.status)) {
            throw new Error('Failed to refresh token');
        }
    }

    async loadBookingSession(token: string): Promise<IDotRezBookingSession> {
        await this.tryRefreshToken(token);
        return new DotRezBookingSession(token, this.services, new VoidDotRezSessionTimer());
    }

    /*
    async createAnonymousToken(): Promise<string> {
        let credentials: any = {};
        if(this.services.configuration.isProduction) {
            credentials =  {
                username: "searchMask",
                password: "zGC0#BiuQ1C00cP",
                domain: "WW2",
                location: "WWW",
                channelType: "Web",
                loginRole: "WWWA"
            };
        }
        const response = await fetch(this.buildDotRezUrl(`/api/nsk/v1/token`), {
            method: 'POST',
            body: JSON.stringify({
                applicationName: ApplicationName,
                credentials: credentials
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if(isHttpErrorStatusCode(response.status)) {
            const statusMessage = `${response.status} - ${response.statusText}`;
            this.services.logger.error(`_createTokenAsync failed: ${statusMessage}`);
            throw new Error(statusMessage);
        }

        const json = await response.json();

        return json.data.token;
    }
*/



}
